(function () {
  function pushPathEvent(link) {
    var root = link.closest('[data-cs-instagram]');
    if (!root) return;
    var detail = {
      path: link.getAttribute('data-cs-instagram-path') || '',
      link_url: link.href || '',
      link_text: (link.textContent || '').replace(/\s+/g, ' ').trim(),
      section: link.getAttribute('data-cs-instagram-position') || '',
      position: link.getAttribute('data-cs-instagram-position') || '',
      content_type: link.getAttribute('data-cs-instagram-content') || ''
    };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: 'cs_instagram_path_click' }, detail));
    try {
      window.dispatchEvent(new CustomEvent('cs:analytics', {
        detail: Object.assign({ eventName: 'cs_instagram_path_click' }, detail)
      }));
    } catch (error) {}
  }

  function init(root) {
    root.querySelectorAll('[data-cs-instagram-path]').forEach(function (link) {
      link.addEventListener('click', function () { pushPathEvent(link); });
    });
    var video = root.querySelector('[data-instagram-video-id]');
    var playVideo = function () {
      if (!video || video.getAttribute('data-playing') === 'true') return;
      var id = video.getAttribute('data-instagram-video-id');
      if (!id) return;
      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0';
      iframe.title = 'MicroBio+ in 60 Sekunden erklärt';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.allowFullscreen = true;
      video.setAttribute('data-playing', 'true');
      video.replaceChildren(iframe);
    };
    root.querySelectorAll('.cs-instagram-video__poster, [data-instagram-video-trigger]').forEach(function (button) {
      button.addEventListener('click', playVideo);
    });
    if (root.getAttribute('data-cs-instagram-animation') !== 'true' || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    root.classList.add('cs-instagram-landing--motion');
    window.requestAnimationFrame(function () { root.classList.add('cs-instagram-landing--ready'); });
    var story = root.querySelector('.cs-instagram-story');
    if (!story) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          story.classList.add('is-revealed');
          observer.disconnect();
        }
      });
    }, { threshold: 0.28 });
    observer.observe(story);
  }

  function ready() { document.querySelectorAll('[data-cs-instagram]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true }); else ready();
})();
